// extracted by mini-css-extract-plugin
export default {"mgContainer":"container_mgContainer__rwD2t","mgContainer__small":"container_mgContainer__small__4yP0C"};